import { queryOptions } from '@tanstack/react-query';
import { QueryKeys } from 'utils/queryKeys';
import { DocumentServiceFoldersRepository } from 'services/folders/DocumentServiceFoldersRepository';

const listFolders = queryOptions({
  queryKey: QueryKeys.contentLibrarySectionsFolders,
  queryFn: async () => await DocumentServiceFoldersRepository.listFolders({ type: 'SECTION' }),
});

export const sectionsQueries = {
  listFolders,
};
